const mapHeadingTypesToOrder = (type) => {
  switch (type) {
    case "display":
      return 1;
    case "h1":
      return 1;
    case "h2":
      return 2;
    case "h3":
      return 3;
    case "h4":
      return 4;
    default:
      return 1;
  }
};
export {
  mapHeadingTypesToOrder
};
